import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-959ccd9c")

_pushScopeId("data-v-959ccd9c")
const _hoisted_1 = { class: "signup-div" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "main-heading" }, " &MEMBERSHIP", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "heading" }, "TAP THE SCREEN TO SIGN UP", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, {
    onClick: _cache[1] || (_cache[1] = $event => (_ctx.goTo('/loyalty/guest/signup')))
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_ion_icon, {
          class: "membership-icon",
          icon: "/assets/icons/Asset_1.svg"
        }),
        _hoisted_2,
        _hoisted_3
      ])
    ]),
    _: 1
  }))
})